import { createAction, props } from '@ngrx/store';

import { SortActivityMode, UserSession } from 'app/shared/models';

export const initializeUserSessionStore = createAction('[UserSession] Init Store');

export const initializeUserSessionStoreSuccess = createAction(
    '[UserSession] Init Store Success',
    props<{
        userSession: UserSession | undefined;
        history: UserSession[];
    }>(),
);

export const loginSuccess = createAction(
    '[UserSession] Login Success',
    props<{ userSession: UserSession }>(),
);

export const startUserSessionExpirationMonitoring = createAction(
    '[UserSession] Start User Session Expiration Monitoring',
);

export const userLogout = createAction('[UserSession] User Logout');

export const supervisorLogout = createAction('[UserSession] Supervisor Logout');

export const userSessionExpiring = createAction(
    '[UserSession] Expiring',
    props<{ userSession: UserSession; expirationTimestamp: number }>(),
);

export const userSessionClosed = createAction(
    '[UserSession] Closed',
    props<{ userSession: UserSession | undefined; timestamp: number; sessionExpired: boolean }>(),
);

export const userSessionHistoryUpdated = createAction(
    '[UserSession] User Session History Updated',
    props<{ userSession: UserSession }>(),
);

export const updatingUserRecentActivities = createAction(
    '[UserSession] Updating Recent Activities',
    props<{ activityNumber: number }>(),
);

export const updatingSortActivityModeInPersonalUserPreferences = createAction(
    '[UserSession] Updating Sort Activity Mode',
    props<{ sortActivityMode: SortActivityMode }>(),
);
